function throttle(func: (...args: any[]) => any, time: number): (...args: any[]) => any {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return function dummy(...args: any[]): any {
    if (!timeout) {
      timeout = setTimeout(() => {
        func(...args);
        timeout = null;
      }, time);
    }
  };
}

export default throttle;
